
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/apply",
      function () {
        return require("private-next-pages/apply/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/apply"])
      });
    }
  